import {
  MONTHS_IN_YEAR,
  READABLE_APP_NAMES,
  SubscriptionInterval,
  TRIAL_BILLING_CYCLE_KEYS,
  TRIAL_DAILY_PERIOD,
  TRIAL_MONTHLY_PERIOD,
  TrialBillingCycle,
} from 'root-constants'

export const getBillingCycleKey = (daysCount: number) => {
  if (
    daysCount < TrialBillingCycle.SEVEN_DAYS ||
    daysCount === TrialBillingCycle.TEN_DAYS
  ) {
    return TRIAL_DAILY_PERIOD
  }

  return TRIAL_BILLING_CYCLE_KEYS[daysCount] || TRIAL_MONTHLY_PERIOD
}

export const getBillingPeriodTranslation = (
  interval?: string,
  intervalCount = 0,
): { key: string; count: number } => {
  if (interval === SubscriptionInterval.YEAR) {
    return {
      key: 'subscription.billingPeriods.month',
      count: intervalCount * MONTHS_IN_YEAR,
    }
  }

  if (interval === SubscriptionInterval.MONTH) {
    return { key: 'subscription.billingPeriods.month', count: intervalCount }
  }

  if (interval === SubscriptionInterval.WEEK) {
    return { key: 'subscription.billingPeriods.week', count: intervalCount }
  }

  return {
    key: `subscription.trialBillingPeriods.${getBillingCycleKey(
      intervalCount,
    )}`,
    count: intervalCount,
  }
}

const getContractPeriod = (interval: string, intervalCount: number): string => {
  if (interval === SubscriptionInterval.YEAR) {
    return intervalCount === 1 ? 'annual' : `${intervalCount}-year`
  }

  if (interval === SubscriptionInterval.MONTH) {
    return `${intervalCount}-month`
  }

  return `${intervalCount}-${interval}`
}

export const getContractLabel = (
  appName: string,
  interval?: string,
  intervalCount?: number,
): string => {
  const name = `${READABLE_APP_NAMES[appName]} Premium`

  return interval && intervalCount
    ? `${name} ${getContractPeriod(interval, intervalCount)}`
    : name
}
